import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import SearchIcon from './search-icon'

const SearchBoxContainer = styled.div`
  display: flex;
`

const SearchIconContainer = styled.div`
  background: #eee;
  border: solid 1px #ccc;
  border-left: none;
  display: flex;
  padding: 0 10px;
  align-items: center;
  line-height: 1;
  cursor: pointer;
  &:hover {
    background: #ddd;
  }
  svg {
    width: 15px;
  }
`

const SearchBox = styled.input`
  padding: 7px 10px;
  min-width: 300px;
  font-size: 14px;
  border: 1px solid #ccc;
  &:focus {
    border-color: #66afe9;
    outline: 0;
  }
`

const ItemSearch = ({ searchText = '', history }) => {
  const [userInput, setUserInput] = useState(searchText)

  return (
    <SearchBoxContainer>
      <SearchBox
        placeholder="Enter Search Text"
        onChange={e => setUserInput(e.target.value)}
        onKeyPress={e => {
          if (e.key === 'Enter' && userInput) {
            history.push(`/find/${userInput}`)
          }
        }}
        value={userInput}
      />
      <SearchIconContainer
        onClick={() => {
          if (userInput) history.push(`/find/${userInput}`)
        }}
      >
        <SearchIcon />
      </SearchIconContainer>
    </SearchBoxContainer>
  )
}

export default withRouter(ItemSearch)
